module.exports = __webpack_public_path__ + "static/media/image032.165e9c5a.jpg";